<style>
textarea {
    width: 100%;
    min-height: 100px;
}

.holder {
    padding-top: 10px;
    padding-bottom: 10px;
}

.pell {
    border-radius: 10px;
    border: 1px solid #ccc;
    margin: 0 0 0.5em 0;
    background-color: white;
}

:global(.pell-content) {
    height: 200px !important;
    overflow: auto;
}

#fileElem {
    display: none;
}
</style>

<script>
import pell from 'pell'
import {onMount} from 'svelte'
import * as Common from './Common.js';

export let addComment;
export let hideWidget;

let newComment = ''
let fileElem
let editor

onMount(async () => {
    pell.init({
    element: editor,
    onChange: html => newComment = html.replace('https://ik.imagekit.io/plantogether/', 'IMG_URL/'),
    defaultParagraphSeparator: 'div',
    styleWithCSS: false,
    actions: [
        'bold',
        'underline',
        'italic',
        'strikethrough',
        'olist',
        'ulist',
        {
            name: 'link',
            result: () => {
                const url = window.prompt('Enter the link URL')
                if (url) pell.exec('createLink', url)
            }
        },
        {
            name: 'image',
            result: () => {
                addPicture()
            }
        }
    ],
    classes: {
        actionbar: 'pell-actionbar',
        button: 'pell-button',
        content: 'pell-content',
        selected: 'pell-button-selected'
    }
    })
})

function submitAddComment() {
    addComment({content: newComment})
    newComment = ''
}

function insertLink() {
    let linkURL = prompt("Please enter the URL of the link you want insert:");
    if(!linkURL) {
        return
    }
    newComment += '[' + linkURL + ']'
}

function addPicture() {
    editor.content.focus()
    if (fileElem) {
        fileElem.click();
    }
}

function onFileAdd(e) {
    // UploadFile
    if(fileElem.files.length == 0) {
        return;
    }

    let formData = new FormData();

    Common.getData("imageuploadtoken")
    .then(data => {
        console.log(data)

        formData.append("file", fileElem.files[0]);
        formData.append("fileName", fileElem.files[0].name);
        formData.append("publicKey", "public_we5ticUsUXZ7EafhcSIbwfOjDTo=")
        formData.append("token",data.token)
        formData.append("expire",data.expire)
        formData.append("signature",data.signature)

        Common.CreateNotification({body: "Uploading Picture!"}, 500)

        fetch('https://upload.imagekit.io/api/v1/files/upload', {
            method: 'POST',
            body: formData
        })
        .then(r => {
            if(r.status != 200) {
                alert("Error uploading picture.");
                r.text().then(t => console.log(t))
                return
            }
            return r.json()
        })
        .then(data => {
            pell.exec('insertImage', 'https://ik.imagekit.io/plantogether/'+ data.name)
        })
    })
}
</script>

<div class="holder">
    <input bind:this={fileElem} multipart type="file" id="fileElem" accept="image/*" style="display:none" on:change={onFileAdd}>
    <div class="pell" bind:this={editor}></div>
    <div class="control-single" on:click={hideWidget}>Cancel</div>
    <div class="control-single" on:click={submitAddComment}>Post Comment</div>
</div>